import React, { useRef, useContext, useEffect, useState } from 'react'
import Slider from 'react-slick'
import './participate-section.scss'
import 'slick-carousel/slick/slick.css'
import 'slick-carousel/slick/slick-theme.css'
import Button from '../../atoms/button/button'
import RomboPuntosRedeem from '../../atoms/rombo-puntos-redeem/rombo-puntos-redeem'
import { costActivity } from '../../../constants/activity-constants'
import DiamondButton from '../../atoms/diamond-button/diamond-button'
import useMediaQuery from '../../../utils/useMediaQuery'
import getUrlIdRegister from '../../../utils/getUrlIdRegister'
import { siteUrl } from '../../../shared/utils/siteUrl'
import { navigate } from 'gatsby'
import { Context } from '../../../context/app-context'
import userSessionStorage from '../../../utils/userSessionStorage'
import { pushEventData } from '../../../utils/pushEventDataLayer'


import Chevron from '../../../assets/images/chevron-pink.png'
import PlayIcon from '../../../assets/images/play-icon.png'
import ItemsIcon from '../../../assets/images/participate-section/item-icon.svg'
import FirstCardFriends from '../../../assets/images/participate-section/card-friends-1.png'
import SecondCard from '../../../assets/images/participate-section/card-product-redime-2.png'
import FourthCard from '../../../assets/images/participate-section/card-young-pretty-woman-4.png'


import Show from '../../../utils/show'
import premioProductImg from '../../../utils/premiosImg'



const LOCALE = ['es-EC', 'es-BO', 'es-PE', 'es-AR', 'es-DO', 'es-PY'].indexOf(process.env.LOCALE) > -1 ? process.env.LOCALE : 'default';
const italilatam = LOCALE === 'es-AR' || LOCALE === 'es-PY';

const CardItem = ({
  cardNumber,
  cardNumberInvert = false,
  leftContent,
  children,
  numberCard,
  slickRef,
}) => {
  return (
    <div className="f-participate-section-container__slider__item__card">
      <div className={'f-participate-section-container__slider__item__card__number ' + (cardNumberInvert && '--invert')}>
        {cardNumber}
      </div>
      <div
        className={`f-participate-section-container__slider__item__wrapper --${numberCard}`}
      >


        {
          leftContent &&
          <div className="f-participate-section-container__slider__item__wrapper__left">
            {leftContent}
          </div>
        }
        <div className="f-participate-section-container__slider__item__wrapper__right">
          {children}
        </div>
      </div>
      <DiamondButton
        className={'--left --colorBlue'}
        onClick={() => slickRef?.current.slickPrev()}
      />
      <DiamondButton
        className={'--right --colorBlue'}
        onClick={() => slickRef?.current.slickNext()}
      />
    </div>
  )
}

const CardItem1 = ({ slickRef, cardNumber }) => {
  const { dispatch } = useContext(Context)
  const isMobile = useMediaQuery()
  const session = new userSessionStorage()
  const [logged, setlogged] = useState(false)

  useEffect(() => {
    const tokenInfo = session.getToken()
    if (tokenInfo) {
      const userInfo = session.getUserInfo()
      if (userInfo) {
        setlogged(true)
      }
    }
  }, [])

  return (
    <CardItem
      cardNumber={cardNumber}
      leftContent={
        <img
          src={FirstCardFriends}
          alt="Amigas alegres"
        />
      }
      numberCard="first"
      slickRef={slickRef}
    >
      <h4 className="f-participate-section-container__slider__item__title">
        <Show valid={!italilatam}>
          Inicia sesión
        </Show>
        <Show valid={italilatam}>
          Iniciá sesión
        </Show>
      </h4>
      <p className="f-participate-section-container__slider__item__description">
        <Show valid={!italilatam}> <b>¿Ya haces parte de NosotrasOnline?</b></Show>
        <Show valid={italilatam}> <b>¿Ya hacés parte de NosotrasOnline?</b></Show>
        <span className='br' />
        <Show valid={!italilatam}> Para jugar debes{' '}</Show>
        <Show valid={italilatam}> Para jugar debés{' '}</Show>
        <a
          href='#participate'
          onClick={() => {
            pushEventData({
              event: 'Enlaces',
              category: "link",
              action: "click",
              label: 'Iniciar sesión'
            });

            !logged &&
              dispatch({
                type: 'set-modal',
                modalActive: {
                  type: 'login',
                  props: {
                    close: () => {
                      dispatch({ type: 'clear-modal' })
                    },
                    handleSuccess: () => {
                      window.location.reload()
                    },
                    mobile: isMobile,
                  },
                },
              })
          }}
          className="f-participate-section-container__slider__item__link"
        >
          Iniciar sesión
        </a>{' '}
        en Nosotras Online.
        <span className='br' />
        <b>Si aún no estás registrada, ¡Tranquila!</b>
        <span className='br' />
      </p>
      <Button
        className="f-participate-section-container__button__bottom"
        onClick={() => {
          pushEventData({
            event: 'Registro',
            label: 'Regístrate aquí'
          })
          window.open(siteUrl + getUrlIdRegister(), '_blank')
        }}
      >
        Regístrate {italilatam ? 'acá' : 'aquí'}
      </Button>
    </CardItem>
  )
}

const CardItemRedime = ({ slickRef, cardNumber }) => {
  const isMobile = useMediaQuery()

  return (
    <CardItem

      cardNumber={cardNumber}
      leftContent={
        <img
          className='f-participate-section-container__custom --customflexend50'
          src={SecondCard}
          alt="Producto nosotras"
        />}
      numberCard="second"
      slickRef={slickRef}
    >
      <h4 className="f-participate-section-container__slider__item__title">
        <Show valid={!italilatam}>Redime puntos</Show>
        <Show valid={italilatam}>Canjeá puntos</Show>
      </h4>
      <p className="f-participate-section-container__slider__item__description --centerFlex --card2">
        Para poder jugar  {' '}
        <Show valid={!italilatam}>debes redimir</Show>
        <Show valid={italilatam}>debés canjear</Show>
        {' '}
        {!isMobile && <>de tus puntos acumulados.</>}
        <RomboPuntosRedeem points={costActivity} />
        {isMobile && <>de tus puntos acumulados.</>}
      </p>
      <p className="f-participate-section-container__slider__item__description">
        <Show valid={!italilatam}>  <b>Si aún no tienes ¡No te preocupes!</b> Inscribe las claves de tus
          productos Nosotras</Show>
        <Show valid={italilatam}>  <b>Si aún no tenés ¡No te preocupés!</b> Inscribí las claves de tus
          productos Nosotras</Show>
        <span className='br' />
      </p>
      <Button
        className="f-participate-section-container__button__bottom"
        onClick={() => {
          pushEventData({
            event: 'Registro Claves',
            action: 'click claves',
            label: 'Aquí'
          })
          window.open(siteUrl + '/mis-puntos/ingreso-de-claves/', '_blank')
        }}
      >
        {italilatam ? 'Acá' : 'Aquí'}
      </Button>
    </CardItem>
  )
}

const CardItemPlay = ({ slickRef, cardNumber }) => {
  const isMobile = useMediaQuery();
  const description = <><b>
    <Show valid={!italilatam}> Encuentra las palabras escondidas y ubícalas en orden correcto</Show>
    <Show valid={italilatam}> Encontrá las palabras escondidas y ubicalas en el orden correcto</Show>
  </b>{' '}
    hasta formar las frases sobre la rutina perfecta para tu Zona V.</>;
  return (
    <CardItem
      cardNumber={cardNumber}
      cardNumberInvert={!isMobile}
      numberCard={'third'}

      slickRef={slickRef}
    >
      <div className="f-participate-section-container__slider__item__first-section">
        <div className="f-participate-section-container__slider__item__first-section__container">
          <h4 className="f-participate-section-container__slider__item__title">
            <Show valid={!italilatam}>Juega</Show>
            <Show valid={italilatam}>Jugá</Show>
          </h4>
          <p className="f-participate-section-container__slider__item__description --desktopDescription">
            {description}
          </p>
        </div>
      </div>
      <div className="f-participate-section-container__slider__item__scroll --threeScroll">
        <p className="f-participate-section-container__slider__item__description --mobileDescription">
          {description}
        </p>
        <div className="f-participate-section-container__slider__item__second-section">
          <div className="f-participate-section-container__slider__item__second-section__list">
            <img
              className="f-participate-section-container__slider__item__second-section__image"
              src={ItemsIcon}
              alt="Icono item"
            />
            <p className="f-participate-section-container__slider__item__description --firstItem">
              {italilatam ? 'Jugá ' : 'Juega '}en La <span>Habitación Nosotras</span> o en
              <span> El Baño del Loving.</span>
            </p>
          </div>
          <div className="f-participate-section-container__slider__item__second-section__list">
            <img
              className="f-participate-section-container__slider__item__second-section__image"
              src={ItemsIcon}
              alt="Icono item"
            />
            <p className="f-participate-section-container__slider__item__description --secondItem">
              <span>{italilatam ? 'Encontrá ' : 'Encuentra '} las palabras escondidas</span> en cada escenario.
            </p>
          </div>
          <div className="f-participate-section-container__slider__item__second-section__list">
            <img
              className="f-participate-section-container__slider__item__second-section__image"
              src={ItemsIcon}
              alt="Icono item"
            />
            <p className="f-participate-section-container__slider__item__description --thirdItem">
              <span>Cuando {italilatam ? 'encontrés ' : 'encuentres '} las palabras,</span> {italilatam ? 'hacé ' : 'haz '} clic sobre ellas
              y {italilatam ? 'arrastralas ' : 'arrástralas '} hacia su cajón correcto para formar la frase en orden.
            </p>
          </div>
        </div>
        <div className="f-participate-section-container__slider__item__third-section">
          <div className="f-participate-section-container__slider__item__third-section__list">
            <img
              className="f-participate-section-container__slider__item__second-section__image"
              src={ItemsIcon}
              alt="Icono item"
            />
            <p className="f-participate-section-container__slider__item__description --fourthItem">
              El tiempo que te sobre, será sumado a tu marcador.
              <span>
                {' '}Además recibirás 2 puntos por cada palabra que {italilatam ? 'ubiqués ' : 'ubiques '}
                correctamente.
              </span>
            </p>
          </div>
          <div className="f-participate-section-container__slider__item__third-section__list">
            <img
              className="f-participate-section-container__slider__item__second-section__image"
              src={ItemsIcon}
              alt="Icono item"
            />
            <p className="f-participate-section-container__slider__item__description --fifthItem">
              Cuando {italilatam ? 'terminés ' : 'termines '} de ubicar todas las palabras,
              <span> {italilatam ? 'hacé ' : 'haz '} clic en “Finalizar juego”</span>
            </p>
          </div>
        </div>
      </div>
      <div className="f-participate-section-container__slider__item__fourth-section__list">
        <p className="f-participate-section-container__slider__item__subtitle">
          <span className='br' />
          ¿Lista para jugar?
          <span className='br' />
        </p>
        <Button
          className="f-participate-section-container__button__bottom"
          onClick={() => {
            pushEventData({
              event: 'Quiero jugar',
              action: "click juego",
              label: 'Haz clic acá'
            });
            navigate('/game')
          }}
        >
          ¡{italilatam ? 'Hacé ' : 'Haz '} clic acá!
        </Button>
      </div>
    </CardItem>
  )
}

const CardItemVideo = ({ slickRef, cardNumber }) => {
  return (
    <CardItem
      cardNumber={cardNumber}
      leftContent={
        <img
          src={FourthCard}
          alt="Mujer enfocando"
        />}
      numberCard="fourth"
      slickRef={slickRef}
    >
      <h4 className="f-participate-section-container__slider__item__title --centerTitle">
        {italilatam ? 'Mirá ' : 'Mira '} el video
      </h4>
      <img
        className="f-participate-section-container__slider__item__image --playImage"
        src={PlayIcon}
        alt="Icono video"
      />
      <p className="f-participate-section-container__slider__item__description --smallFont">
        <b>¡Dale play al video y {italilatam ? 'ganá ' : 'gana '} 5 puntos adicionales!</b>
        <span className='br' />
        Dale skip si {italilatam ? 'querés ' : 'quieres '} continuar
      </p>
      <p className="f-participate-section-container__slider__item__description --smallFont --width100left">*(No ganarás puntos)</p>

      <span className='br' />

      <p className="f-participate-section-container__slider__item__subtitle">
        <Show valid={!italilatam}>¿Lista?</Show>
        <Show valid={italilatam}>¿Lista para jugar?</Show>
        <span className='br' />
      </p>
      <Button
        className="f-participate-section-container__button__bottom"
        onClick={() => {
          pushEventData({
            event: 'Quiero jugar',
            action: "click juego",
            label: 'Comenzar'
          });
          navigate('/game')
        }}
      >
        <Show valid={!italilatam}>¡Comenzar!</Show>
        <Show valid={italilatam}>¡Hacé clic acá!</Show>
      </Button>
    </CardItem>
  )
}

const CardItemWin = ({ slickRef, cardNumber }) => {


  return (
    <CardItem
      cardNumber={cardNumber}
      leftContent={
        <div className='f-participate-section-container__custom --customflexendColumn50 '>
          <img
            src={premioProductImg}
            alt="Mujer enfocando"
          />
          <span className='f-participate-section-container__custom --span-white-ref  '>*Imagenes de Referencia</span>
        </div>}
      numberCard="fifth"
      slickRef={slickRef}>
      <h4 className="f-participate-section-container__slider__item__title --centerTitle">
        {italilatam ? 'Ganá' : 'Gana'}
      </h4>
      <div className="f-participate-section-container__slider__item__scroll">
        <p className="f-participate-section-container__slider__item__description --smallFont">
          Cada vez que  {italilatam ? 'jugués ' : 'juegues '} tu puntaje se irá sumando a tu puntaje final, así
          que entre más {italilatam ? 'jugués ' : 'juegues '} más puntos {italilatam ? 'acumulás ' : 'acumulas '}.
          <span className='br' />
        </p>

        <Show valid={LOCALE === 'default'}>
          <p className="f-participate-section-container__slider__item__description --smallFont">
            <b>Si estás entre las 10 ganadoras con mejores puntajes, podrás ganar:</b>
          </p>
          <p className="f-participate-section-container__slider__item__description --smallFont">
            <b>Del top 1 al 5:</b> Una waflera para el cabello.
          </p>
          <p className="f-participate-section-container__slider__item__description --smallFont">
            <b>Del top 6 al 10:</b> Un kit de productos Nosotras.
            <span className='br' />
          </p>
        </Show>
        <Show valid={LOCALE === 'es-EC'}>
          <p className="f-participate-section-container__slider__item__description --smallFont">
            <b>Si estás entre las 10 ganadoras con mejores puntajes, podrás ganar:</b>
          </p>
          <p className="f-participate-section-container__slider__item__description --smallFont">
            <b>S Del top 1 al 3:</b> Kit de cuidado de la piel + un kit de productos
          </p>
          <p className="f-participate-section-container__slider__item__description --smallFont">
            <b> Del top 4 al 10: </b>Un kit de productos Nosotras.
          </p>
        </Show>

        <Show valid={LOCALE === 'es-PE'}>
          <p className="f-participate-section-container__slider__item__description --smallFont">
            <b>Si estás entre las 10 ganadoras con mejores puntajes, podrás ganar:</b>
          </p>
          <p className="f-participate-section-container__slider__item__description --smallFont">
            <b>S Del top 1 al 5:</b> Un cepillo secador.
          </p>
          <p className="f-participate-section-container__slider__item__description --smallFont">
            <b> Del top 6 al 10: </b>Un kit de productos Nosotras.
          </p>
        </Show>

        <Show valid={LOCALE === 'es-AR'}>
          <p className="f-participate-section-container__slider__item__description --smallFont">
            <b> Si estás entre las 10 ganadoras con mejores puntajes,</b>
            podrás ganar una bolsa de tela Nosotras con sorpresas espectaculares.
          </p>
        </Show>
        <Show valid={LOCALE === 'es-DO'}>
          <p className="f-participate-section-container__slider__item__description --smallFont">
            <b>Si estás entre las 10 ganadoras con mejores puntajes, podrás ganar: una bolsa de productos Nosotras + merchandising de la marca.</b>
          </p>
        </Show>

        <div className="f-participate-section-container__slider__item__product --customflexendColumn50">
          <img
            src={premioProductImg}
            alt="Imagen de los productos" />
          <span className='f-participate-section-container__custom --span-pink-ref  '>*Imagenes de Referencia</span>
        </div>
        <p className="f-participate-section-container__slider__item__description --smallFont">
          <br />
          Antes de jugar, te recomendamos conocer todos
          <b> los términos y condiciones </b>
          <a
            href="#terms"
            className="f-participate-section-container__slider__item__link"
            onClick={() => {
              pushEventData({
                event: 'Enlaces',
                category: "link",
                action: "click",
                label: 'aquí'
              });
            }}>
            {italilatam ? 'acá' : 'aquí'}
          </a>
          <span className='br' />
        </p>
        <p className="f-participate-section-container__slider__item__description --smallFont">
          <b>Ahora sí, ¡usa tu súper visión, {italilatam ? 'encontrá ' : 'encuentra '} las palabras y {italilatam ? 'ganá!' : 'gana!'}</b>
          <span className='br' />
        </p>
      </div>
      <Button
        className="f-participate-section-container__button__bottom"
        onClick={() => {
          pushEventData({
            event: 'Quiero jugar',
            action: "click juego",
            label: 'Quiero jugar'
          });
          navigate('/game')
        }}
      >
        ¡Quiero jugar!
      </Button>
    </CardItem>
  )
}

const ParticipateSection = () => {
  const slickRef = useRef(null)
  const settings = {
    centerMode: true,
    infinite: false,
    centerPadding: '-60px',
    speed: 500,
    dots: true,
    arrows: false,
  }

  const cards = LOCALE === 'es-BO' ? [(props) => <CardItem1 {...props} />,
  (props) => <CardItemPlay {...props} />,
  (props) => <CardItemVideo {...props} />,
  (props) => <CardItemWin {...props} />
  ] :
    [(props) => <CardItem1 {...props} />,
    (props) => <CardItemRedime {...props} />,
    (props) => <CardItemPlay {...props} />,
    (props) => <CardItemVideo {...props} />,
    (props) => <CardItemWin {...props} />
    ];

  return (
    <div id='participate' className="f-participate-section-container">
      <div className="f-participate-section-container__header">
        <h2 className="f-participate-section-container__header__title">
          ¿Cómo participar?
        </h2>
      </div>
      <section className="f-participate-section-container__content">
        <h3 className="f-participate-section-container__content__subtitle">
          Diviértete mientras aprendes
        </h3>
        <p className="f-participate-section-container__content__description">
          sobre la rutina perfecta para tu Zona V
        </p>
        <p className="f-participate-section-container__content__description1">
          Solo tú seras capaz de conseguir la máxima puntuación.
        </p>
        <p className="f-participate-section-container__content__title">
          ¿Estás lista?
        </p>
        <p className="f-participate-section-container__content__description2">
          Sigue los siguientes pasos:
        </p>
        <img
          className="f-participate-section-container__content__chevron"
          src={Chevron}
          alt="Icono chevron pink"
        />
        <div className="f-participate-section-container__slider">
          <Slider {...settings} ref={slickRef}>

            {
              cards.map((cardView, index) => {
                return <div key={index} className="f-participate-section-container__slider__item">
                  {cardView({ slickRef, cardNumber: index + 1 })}
                </div>
              })
            }

          </Slider>
        </div>
      </section>
    </div>
  )
}

export default ParticipateSection
